import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, switchMap } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly authenticationService = inject(AuthenticationService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (
      !req.url.includes('/secure') &&
      !req.url.includes('/external/labresult-v2-service/')
    ) {
      return next.handle(req);
    }

    if (!this.authenticationService.isLoggedIn()) {
      return EMPTY;
    }

    return this.authenticationService.getToken().pipe(
      switchMap(({ idToken }) =>
        next.handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${idToken}`,
            },
          }),
        ),
      ),
    );
  }
}
